module.exports = __webpack_public_path__ + "assets/cursor_icon.a8057dc9.svg";